var AppConfig_1;
import { __decorate } from "tslib";
import { Injectable, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { toObservable } from "@angular/core/rxjs-interop";
let AppConfig = class AppConfig {
    static { AppConfig_1 = this; }
    http;
    static settings;
    settingsSignal = signal(null);
    $settings = toObservable(this.settingsSignal);
    constructor(http) {
        this.http = http;
    }
    load() {
        const uniqueParam = new Date().getTime();
        const jsonFile = `assets/config/config.json?cacheBuster=${uniqueParam}`;
        return new Promise((resolve, reject) => {
            {
                this.http.get(jsonFile).toPromise().then((response) => {
                    AppConfig_1.settings = response;
                    this.settingsSignal.set(AppConfig_1.settings);
                    resolve();
                }).catch((response) => {
                    reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
                });
            }
        });
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
AppConfig = AppConfig_1 = __decorate([
    Injectable()
], AppConfig);
export { AppConfig };
